export default {
    header: {
        feedback360: '360 Feedback',
        captureInsights: 'Capture insights from all sources',
        forArrowIllustrationAlt: 'Arrow pointing to the right',
        removeReviewee: 'Remove reviewee',
        cannotRemoveLastReviewee: 'At least one reviewee should be there',
    },
    assignReviewers: {
        title: 'Assign Reviewers',
        description:
            "To make things easier for you, we've already identified potential colleagues who may have worked with <bold>{{firstName}} {{lastName}}</bold>.",
        addReviewer: 'Add Reviewers',
        revieweeBadge: 'Reviewee',
        reviewerAlreadySelected: 'Reviewers already selected',
        noReviewersAssigned: 'No reviewers assigned yet.',
        loadingReviewers: 'Loading reviewers...',
        noReviewersFound: 'No reviewers found',
        searchReviewers: 'Search reviewers',
    },
    selectAttributeModal: {
        title: 'Select a New Attribute',
        add: 'Add',
        attributes: {
            jobTitle: 'Colleagues with the same job title',
            manager: 'Colleagues under the same {{managerLabel}}',
            department: 'Colleagues from the same department',
            supervisor: 'Employees who report to the same supervisor',
            division: 'Employees within the same division',
        },
    },
    validation: {
        title: 'Form incomplete',
        noReviewees: 'Please select at least one reviewee.',
        minReviewers: 'Each reviewee must have at least one reviewer assigned.',
        maxReviewers: 'You can assign a maximum of {{count}} reviewers per reviewee.',
    },
    confirmLockedAdditions: {
        title_one: 'Invite this respondent?',
        title_other: 'Invite these respondents?',
        message_one:
            '{{names}} will receive the invitation to this anonymous 360 feedback. Once it is sent, they can no longer be removed.',
        message_other:
            '{{names}} will receive the invitation to this anonymous 360 feedback. Once it is sent, they can no longer be removed.',
        confirm: 'Invite',
    },
    confirmSubmittedRemoval: {
        title: 'Remove {{name}}?',
        message:
            '{{name}} has already submitted their answers. Removing them deletes their answers and comments, along with the replies to their comments.',
        confirm: 'Remove',
    },
};
